import { useCallback } from 'react';
import { logout, saveToken } from '../../Store/authSlice';
import { changeToasterState } from '../../Store/layoutSlice';
import { TOASTER_STATE } from '../../Model/Enums';
import { useAppDispatch } from '../../Store/store';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLazyLoginQuery } from '../../Store/storeApi';

export const useAuthorize = (token: string) => {
  const location = useLocation();
  const [login, { isLoading }] = useLazyLoginQuery();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return {
    authorize: useCallback(async () => {
      try {
        dispatch(saveToken({ token }));
        await login({ token }).unwrap();
      } catch (e) {
        if (e?.status === 403) {
          navigate('/privacy', { replace: true, state: { originalUrl: location?.pathname, token } });
          return;
        }
        dispatch(logout());
        dispatch(changeToasterState(TOASTER_STATE.EXPIRED_LINK));
        navigate('/', { replace: true });
      }
      // eslint-disable-next-line
    }, [dispatch, login, navigate]),
    isLoading,
  };
};
